import { Form, Typography } from "antd";
import { HeaderOverview } from "components";
import {
  ErrorDashboard,
  LoadingDashboard,
  NoDataDashboard,
  WrapperBG,
  checkDataObject,
} from "pages/overview";
import { useAppLanguage } from "providers/app-language";
import { useOverview } from "providers/overview";
import React from "react";
import { useTranslation } from "react-i18next";
import { useGetDashboardFacility } from "service/dashboard/central/facility";

const FacilityUsed = () => {
  const { t } = useTranslation();
  const { translationObject } = useAppLanguage();
  const { findDate, property } = useOverview();

  const mostUsedFacilitiesDate = Form.useWatch("mostUsedFacilitiesDate");
  const date = findDate(mostUsedFacilitiesDate);

  const { data, isFetching, isError, error } = useGetDashboardFacility({
    ...date,
    property,
  });

  const findData = checkDataObject(data);

  const name = data
    ? translationObject({ object: findData[0], keys: ["name"] }).name
    : "";

  return (
    <WrapperBG className="h-full">
      <LoadingDashboard loading={isFetching}>
        <HeaderOverview
          title={t("the-most-used-facilities")}
          name="mostUsedFacilitiesDate"
        />

        <div className="p-5 h-[250px] center flex-col text-center">
          {isError ? (
            <ErrorDashboard error={error} />
          ) : !findData || findData.length <= 0 ? (
            <NoDataDashboard />
          ) : (
            <Typography.Title
              className="!text-[#44955B] w-full"
              ellipsis={{ tooltip: true }}
            >
              {name}
            </Typography.Title>
          )}
        </div>
      </LoadingDashboard>
    </WrapperBG>
  );
};

export default FacilityUsed;
